import React from "react";
import { FormGroup, RadioGroup, Radio, ControlLabel, Panel } from "rsuite";
import styled from "styled-components";

export const QuizQuestionArea = () => {
  return (
    <QuestionArea>
      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
      Lorem Ipsum has been the industry's standard dummy text ever since the
      Ipsum.
    </QuestionArea>
  );
};

export const QuestionOptions = () => {
  return (
    <Panel>
      <FormGroup
        controlId="radioList"
        style={{ fontFamily: "Montserrat,sans-serif" }}
      >
        <RadioGroup name="radioList">
          <ControlLabel>Pick A Answer</ControlLabel>
          <Radio value="A">Item A</Radio>
          <Radio value="B">Item B</Radio>
          <Radio value="C">Item C</Radio>
          <Radio value="D">Item D</Radio>
        </RadioGroup>
      </FormGroup>
    </Panel>
  );
};

export const QuestionButtonArea = () => {
  return <QuestionBar />;
};

const QuestionArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: medium;
  width: 60%;
  /* height: 30%; */
  background-color: #bce0fd;
  font-family: "Montserrat";
  line-height: 1.6;
  overflow: auto;
  padding: 10px 10px;
  text-align: center;
`;

const QuestionBar = styled.div`
  display: grid;
  flex-direction: column;
  color: white;
  width: 25%;
  height: 1080px;
  background: #233975;
`;
